import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProvider"] */ "/app/context/GlobalContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
